import React from 'react'

import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import KinerjaHarianLogs from 'app/KinerjaHarian/pages/KinerjaHarianLogs'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { PageGuardGuru } from 'app/KinerjaPage/components/PageGuardGuru'
import { PageGuardKinerjaHarian } from 'app/KinerjaHarian/components/PageGuardKinerjaHarian'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'
import { KinerjaHarianRoleProvider } from 'app/KinerjaHarian/components/KinerjaHarianRoleProvider'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-enabled'] || false
    const enabledHarian = toggle?.['kinerja-harian-enabled'] || false

    if (!enabled || !enabledHarian) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const KinerjaIndex = () => {
  return (
    <KinerjaTipeProvider tipe="SPF">
      <KinerjaHarianRoleProvider role="GURU">
        <PageGuardGuru>
          <PageGuardKinerjaHarian>
            <KinerjaHarianLogs />
          </PageGuardKinerjaHarian>
        </PageGuardGuru>
      </KinerjaHarianRoleProvider>
    </KinerjaTipeProvider>
  )
}

KinerjaIndex.Layout = KinerjaLayout

KinerjaIndex.layoutOpts = {
  hasHeader: true,
}

export default KinerjaIndex
